<div class="container">
	<p class="text-center">
		<img src="/assets/img/404.gif" alt="not found">
	</p>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/404/404.html